import { render } from "./Kpi.vue?vue&type=template&id=482259da&scoped=true"
import script from "./Kpi.vue?vue&type=script&lang=js"
export * from "./Kpi.vue?vue&type=script&lang=js"

import "./Kpi.vue?vue&type=style&index=0&id=482259da&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482259da"]])

export default __exports__